import { Injectable } from '@angular/core';
import {  LearningObjectiveOrder } from './../model/model';
import { HttpClient } from '@angular/common/http';
import { UserService } from './user.service';
@Injectable()
export class SchoolService {
    public queryEndPoint = 'query-api/School';

    constructor(private http: HttpClient, protected userService: UserService) { }

    getLearningObjectiveOrder = () => this.http.get<LearningObjectiveOrder[]>
        (`${this.queryEndPoint}/${this.userService.user.schoolId}/LearningObjectiveOrders`)
}
